import { createTheme } from '@material-ui/core/styles';
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: '#208711',
      light: '#30da79',
      dark: '#009A44',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#BCED09',
      light: '#F9CB40',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: `"Lato", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 50,
  },
  overrides: {
    MuiTextField: {
      root: {
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: 'rgb(250, 232, 241)',
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'rgb(232, 241, 250)',
          },
        },
        '&.Mui-focused': {
          backgroundColor: 'rgb(250, 241, 232)',
        },
      },
    },
  },
});

theme.overrides = {
  MuiToolbar: {
    root: {
      color: theme.palette.primary.contrastText,
      '& a': {
        color: '#009A44',
        marginLeft: '20px',
        textDecoration: 'none',
        '&:hover': {
          color: '#009a43d5',
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            color: '#BCED09',
          },
        },
        '&.Mui-focused': {
          color: '#BCED09',
        },
      },
    },
  },
  MuiButton: {
    contained: {
      backgroundColor: '#00ab75',
      fontWeight: 'bold',
      '&:hover': {
        color: '#FFFFFF',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          color: '#FFFFFF',
        },
      },
      padding: '7px 21px 5px 21px',
    },
    label: {
      color: '#FFFFFF',
    },
  },
  MuiIconButton: {
    label: {
      color: theme.palette.primary.main,
      '& .MuiSvgIcon-root': {
        '&:checked': {},
      },
    },
  },
  MuiSvgIcon: {
    root: {
      color: theme.palette.primary.main,
    },
  },
  MuiCheckbox: {
    checked: {
      backgroundColor: '#000000',
    },
    input: {
      backgroundColor: '#000000',
    },
  },
};

export default theme;
